/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/_home/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as AuthenticatedAuditLogIndexRouteImport } from './routes/_authenticated/audit-log/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedDiscountCodesIndexRouteImport } from './routes/_authenticated/discount-codes/index'
import { Route as AuthenticatedEmployeesIndexRouteImport } from './routes/_authenticated/employees/index'
import { Route as AuthenticatedFinancesIndexRouteImport } from './routes/_authenticated/finances/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedTripsIndexRouteImport } from './routes/_authenticated/trips/index'
import { Route as LoginCallbackIndexRouteImport } from './routes/login/callback/index'
import { Route as AuthenticatedClientsIdIndexRouteImport } from './routes/_authenticated/clients/$id/index'
import { Route as AuthenticatedDiscountCodesIdIndexRouteImport } from './routes/_authenticated/discount-codes/$id/index'
import { Route as AuthenticatedEmployeesIdIndexRouteImport } from './routes/_authenticated/employees/$id/index'
import { Route as AuthenticatedTripsIdIndexRouteImport } from './routes/_authenticated/trips/$id/index'
import { Route as AuthenticatedTripsNewIndexRouteImport } from './routes/_authenticated/trips/new/index'
import { Route as AuthenticatedTripsIdEditIndexRouteImport } from './routes/_authenticated/trips/$id/edit/index'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/_home/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAuditLogIndexRoute =
  AuthenticatedAuditLogIndexRouteImport.update({
    id: '/audit-log/',
    path: '/audit-log/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDiscountCodesIndexRoute =
  AuthenticatedDiscountCodesIndexRouteImport.update({
    id: '/discount-codes/',
    path: '/discount-codes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmployeesIndexRoute =
  AuthenticatedEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFinancesIndexRoute =
  AuthenticatedFinancesIndexRouteImport.update({
    id: '/finances/',
    path: '/finances/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTripsIndexRoute = AuthenticatedTripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const LoginCallbackIndexRoute = LoginCallbackIndexRouteImport.update({
  id: '/login/callback/',
  path: '/login/callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedClientsIdIndexRoute =
  AuthenticatedClientsIdIndexRouteImport.update({
    id: '/clients/$id/',
    path: '/clients/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDiscountCodesIdIndexRoute =
  AuthenticatedDiscountCodesIdIndexRouteImport.update({
    id: '/discount-codes/$id/',
    path: '/discount-codes/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmployeesIdIndexRoute =
  AuthenticatedEmployeesIdIndexRouteImport.update({
    id: '/employees/$id/',
    path: '/employees/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTripsIdIndexRoute =
  AuthenticatedTripsIdIndexRouteImport.update({
    id: '/trips/$id/',
    path: '/trips/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTripsNewIndexRoute =
  AuthenticatedTripsNewIndexRouteImport.update({
    id: '/trips/new/',
    path: '/trips/new/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTripsIdEditIndexRoute =
  AuthenticatedTripsIdEditIndexRouteImport.update({
    id: '/trips/$id/edit/',
    path: '/trips/$id/edit/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedHomeIndexRoute
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/audit-log/': typeof AuthenticatedAuditLogIndexRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/discount-codes/': typeof AuthenticatedDiscountCodesIndexRoute
  '/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/finances/': typeof AuthenticatedFinancesIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/trips/': typeof AuthenticatedTripsIndexRoute
  '/login/callback/': typeof LoginCallbackIndexRoute
  '/clients/$id/': typeof AuthenticatedClientsIdIndexRoute
  '/discount-codes/$id/': typeof AuthenticatedDiscountCodesIdIndexRoute
  '/employees/$id/': typeof AuthenticatedEmployeesIdIndexRoute
  '/trips/$id/': typeof AuthenticatedTripsIdIndexRoute
  '/trips/new/': typeof AuthenticatedTripsNewIndexRoute
  '/trips/$id/edit/': typeof AuthenticatedTripsIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/': typeof AuthenticatedHomeIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/audit-log': typeof AuthenticatedAuditLogIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/discount-codes': typeof AuthenticatedDiscountCodesIndexRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/finances': typeof AuthenticatedFinancesIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/trips': typeof AuthenticatedTripsIndexRoute
  '/login/callback': typeof LoginCallbackIndexRoute
  '/clients/$id': typeof AuthenticatedClientsIdIndexRoute
  '/discount-codes/$id': typeof AuthenticatedDiscountCodesIdIndexRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdIndexRoute
  '/trips/$id': typeof AuthenticatedTripsIdIndexRoute
  '/trips/new': typeof AuthenticatedTripsNewIndexRoute
  '/trips/$id/edit': typeof AuthenticatedTripsIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_authenticated/_home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/audit-log/': typeof AuthenticatedAuditLogIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/discount-codes/': typeof AuthenticatedDiscountCodesIndexRoute
  '/_authenticated/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/_authenticated/finances/': typeof AuthenticatedFinancesIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/trips/': typeof AuthenticatedTripsIndexRoute
  '/login/callback/': typeof LoginCallbackIndexRoute
  '/_authenticated/clients/$id/': typeof AuthenticatedClientsIdIndexRoute
  '/_authenticated/discount-codes/$id/': typeof AuthenticatedDiscountCodesIdIndexRoute
  '/_authenticated/employees/$id/': typeof AuthenticatedEmployeesIdIndexRoute
  '/_authenticated/trips/$id/': typeof AuthenticatedTripsIdIndexRoute
  '/_authenticated/trips/new/': typeof AuthenticatedTripsNewIndexRoute
  '/_authenticated/trips/$id/edit/': typeof AuthenticatedTripsIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login/'
    | '/onboarding/'
    | '/analytics/'
    | '/audit-log/'
    | '/clients/'
    | '/discount-codes/'
    | '/employees/'
    | '/finances/'
    | '/roles/'
    | '/settings/'
    | '/trips/'
    | '/login/callback/'
    | '/clients/$id/'
    | '/discount-codes/$id/'
    | '/employees/$id/'
    | '/trips/$id/'
    | '/trips/new/'
    | '/trips/$id/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/onboarding'
    | '/'
    | '/analytics'
    | '/audit-log'
    | '/clients'
    | '/discount-codes'
    | '/employees'
    | '/finances'
    | '/roles'
    | '/settings'
    | '/trips'
    | '/login/callback'
    | '/clients/$id'
    | '/discount-codes/$id'
    | '/employees/$id'
    | '/trips/$id'
    | '/trips/new'
    | '/trips/$id/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login/'
    | '/onboarding/'
    | '/_authenticated/_home/'
    | '/_authenticated/analytics/'
    | '/_authenticated/audit-log/'
    | '/_authenticated/clients/'
    | '/_authenticated/discount-codes/'
    | '/_authenticated/employees/'
    | '/_authenticated/finances/'
    | '/_authenticated/roles/'
    | '/_authenticated/settings/'
    | '/_authenticated/trips/'
    | '/login/callback/'
    | '/_authenticated/clients/$id/'
    | '/_authenticated/discount-codes/$id/'
    | '/_authenticated/employees/$id/'
    | '/_authenticated/trips/$id/'
    | '/_authenticated/trips/new/'
    | '/_authenticated/trips/$id/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  LoginCallbackIndexRoute: typeof LoginCallbackIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_home/': {
      id: '/_authenticated/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit-log/': {
      id: '/_authenticated/audit-log/'
      path: '/audit-log'
      fullPath: '/audit-log/'
      preLoaderRoute: typeof AuthenticatedAuditLogIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/discount-codes/': {
      id: '/_authenticated/discount-codes/'
      path: '/discount-codes'
      fullPath: '/discount-codes/'
      preLoaderRoute: typeof AuthenticatedDiscountCodesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employees/': {
      id: '/_authenticated/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AuthenticatedEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/finances/': {
      id: '/_authenticated/finances/'
      path: '/finances'
      fullPath: '/finances/'
      preLoaderRoute: typeof AuthenticatedFinancesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trips/': {
      id: '/_authenticated/trips/'
      path: '/trips'
      fullPath: '/trips/'
      preLoaderRoute: typeof AuthenticatedTripsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/login/callback/': {
      id: '/login/callback/'
      path: '/login/callback'
      fullPath: '/login/callback/'
      preLoaderRoute: typeof LoginCallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/clients/$id/': {
      id: '/_authenticated/clients/$id/'
      path: '/clients/$id'
      fullPath: '/clients/$id/'
      preLoaderRoute: typeof AuthenticatedClientsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/discount-codes/$id/': {
      id: '/_authenticated/discount-codes/$id/'
      path: '/discount-codes/$id'
      fullPath: '/discount-codes/$id/'
      preLoaderRoute: typeof AuthenticatedDiscountCodesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employees/$id/': {
      id: '/_authenticated/employees/$id/'
      path: '/employees/$id'
      fullPath: '/employees/$id/'
      preLoaderRoute: typeof AuthenticatedEmployeesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trips/$id/': {
      id: '/_authenticated/trips/$id/'
      path: '/trips/$id'
      fullPath: '/trips/$id/'
      preLoaderRoute: typeof AuthenticatedTripsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trips/new/': {
      id: '/_authenticated/trips/new/'
      path: '/trips/new'
      fullPath: '/trips/new/'
      preLoaderRoute: typeof AuthenticatedTripsNewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trips/$id/edit/': {
      id: '/_authenticated/trips/$id/edit/'
      path: '/trips/$id/edit'
      fullPath: '/trips/$id/edit/'
      preLoaderRoute: typeof AuthenticatedTripsIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedAuditLogIndexRoute: typeof AuthenticatedAuditLogIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedDiscountCodesIndexRoute: typeof AuthenticatedDiscountCodesIndexRoute
  AuthenticatedEmployeesIndexRoute: typeof AuthenticatedEmployeesIndexRoute
  AuthenticatedFinancesIndexRoute: typeof AuthenticatedFinancesIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTripsIndexRoute: typeof AuthenticatedTripsIndexRoute
  AuthenticatedClientsIdIndexRoute: typeof AuthenticatedClientsIdIndexRoute
  AuthenticatedDiscountCodesIdIndexRoute: typeof AuthenticatedDiscountCodesIdIndexRoute
  AuthenticatedEmployeesIdIndexRoute: typeof AuthenticatedEmployeesIdIndexRoute
  AuthenticatedTripsIdIndexRoute: typeof AuthenticatedTripsIdIndexRoute
  AuthenticatedTripsNewIndexRoute: typeof AuthenticatedTripsNewIndexRoute
  AuthenticatedTripsIdEditIndexRoute: typeof AuthenticatedTripsIdEditIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  AuthenticatedAuditLogIndexRoute: AuthenticatedAuditLogIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedDiscountCodesIndexRoute: AuthenticatedDiscountCodesIndexRoute,
  AuthenticatedEmployeesIndexRoute: AuthenticatedEmployeesIndexRoute,
  AuthenticatedFinancesIndexRoute: AuthenticatedFinancesIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTripsIndexRoute: AuthenticatedTripsIndexRoute,
  AuthenticatedClientsIdIndexRoute: AuthenticatedClientsIdIndexRoute,
  AuthenticatedDiscountCodesIdIndexRoute:
    AuthenticatedDiscountCodesIdIndexRoute,
  AuthenticatedEmployeesIdIndexRoute: AuthenticatedEmployeesIdIndexRoute,
  AuthenticatedTripsIdIndexRoute: AuthenticatedTripsIdIndexRoute,
  AuthenticatedTripsNewIndexRoute: AuthenticatedTripsNewIndexRoute,
  AuthenticatedTripsIdEditIndexRoute: AuthenticatedTripsIdEditIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  LoginCallbackIndexRoute: LoginCallbackIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
